import { Controller } from '@hotwired/stimulus'
import BarReviewEssayFeedbackChannel from 'channels/bar_review/essay_feedback_channel'

export default class extends Controller {
  static values = {
    userWritingId: String,
    updateNeeded: Boolean
  }

  static targets = ["feedback", "voting"]

  initialize() {
    if (this.updateNeededValue) {
      this.channel = new BarReviewEssayFeedbackChannel(this.userWritingIdValue, this.feedbackTarget, this.votingTarget)
      this.channel.start()
    }
  }
}
